import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExamResultComponent } from "./exam-result.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatDialogModule } from "@angular/material/dialog";
import { TranslocoModule } from "@ngneat/transloco";

@NgModule({
  imports: [
    TranslocoModule,
    FuseSharedModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDialogModule,
  ],
  declarations: [ExamResultComponent],
})
export class ExamResultModule { }
